import { NEW_OPPORTUNITIY_START, NEW_OPPORTUNITIY_SUCCESS, NEW_OPPORTUNITIY_FAIL } from '../actions/ActionsTypes';

const initialState = {
    success: false,
    error: null,
    loading: false,
};


export default function (state = initialState, action) {
    switch (action.type) {
        case NEW_OPPORTUNITIY_START:
            return {
                ...state,
                loading: true,
                error: false
            }
        case NEW_OPPORTUNITIY_SUCCESS:
            return {
                ...state,
                success: true,
                error: null,
                loading: false
            }
        case NEW_OPPORTUNITIY_FAIL:
            return {
                ...state,
                success: false,
                error: true,
                loading: false,
            }
        default:
            return state;
    }
}